export enum FileType {
    txt = "txt",
    pdf = "pdf",
    mp3 = "mp3",
    mp4 = "mp4"
}
